module.exports = __webpack_public_path__ + "static/media/logo-npm.d631bf07.svg";